import React from 'react';
import { formatCell } from '../../utils/consolidatedTable';

/* Tabla consolidada de ventas (metricId ventas_consolidadas). Muestra exactamente lo que devolvió el servidor:
   filas, una fila de totales ("Acumulado" por fecha, "Total" en las demás vistas) y los importes aparte de los conteos. */
export default function ConsolidatedTable({ entry, onExport, exporting }) {
  const columns = entry?.columns || [];
  const rows = entry?.data || [];
  const hasRows = rows.length > 0 && columns.length > 0;
  const message = entry?.metadata?.message;
  const overlap = entry?.metadata?.groups_overlap;

  if (!hasRows) {
    return (
      <div role="status" data-testid="consolidated-empty" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', fontSize: 12, color: '#6b6b66', padding: 12 }}>
        {message || 'Sin ventas en el período y la selección actuales.'}
      </div>
    );
  }

  const alignOf = (column) => (column.type === 'text' ? 'left' : 'right');
  const cell = { padding: '6px 10px', fontSize: 12, borderBottom: '1px solid #f0f0ec', whiteSpace: 'nowrap' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minHeight: 0, flex: 1 }} data-testid="consolidated-table">
      {onExport && (
        <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
          <button type="button" disabled={Boolean(exporting)} onClick={() => onExport('excel')} style={buttonStyle}>
            {exporting === 'excel' ? 'Exportando…' : 'Excel'}
          </button>
          <button type="button" disabled={Boolean(exporting)} onClick={() => onExport('pdf')} style={buttonStyle}>
            {exporting === 'pdf' ? 'Exportando…' : 'PDF'}
          </button>
        </div>
      )}
      <div style={{ overflow: 'auto', minHeight: 0 }}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.id} scope="col" style={{ ...cell, textAlign: alignOf(column), fontWeight: 600, background: '#f7f7f5', position: 'sticky', top: 0 }}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={row.key ?? index}>
                {columns.map((column) => (
                  <td key={column.id} style={{ ...cell, textAlign: alignOf(column) }}>{formatCell(column, row[column.id])}</td>
                ))}
              </tr>
            ))}
          </tbody>
          {entry.totals && (
            <tfoot>
              <tr data-testid="consolidated-totals">
                {columns.map((column) => (
                  <th key={column.id} scope="row" style={{ ...cell, textAlign: alignOf(column), fontWeight: 700, background: '#f3f4f6', borderTop: '2px solid #111827' }}>
                    {formatCell(column, entry.totals[column.id])}
                  </th>
                ))}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      {overlap && (
        <div role="note" style={{ fontSize: 11, color: '#92400e' }}>
          Una sucursal que está en más de un grupo aparece en cada uno de ellos; la fila Total la cuenta una sola vez.
        </div>
      )}
      {entry.metadata?.truncated && (
        <div role="note" style={{ fontSize: 11, color: '#92400e' }}>La tabla se recortó por tamaño: reduce el período o la selección.</div>
      )}
    </div>
  );
}

const buttonStyle = {
  padding: '4px 10px', fontSize: 11, fontWeight: 600, cursor: 'pointer', borderRadius: 6,
  border: '1px solid rgba(0,0,0,0.14)', background: '#fff', fontFamily: 'inherit',
};
